export default "__VITE_ASSET__6SCU_pKO__"